var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-title',[_vm._v("Catégories produits virtuel")]),_c('show-categories',{attrs:{"is-virtual":"","type":"Product"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }